/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Package_CountInputs */

const vi_carrier_form_package_count = /** @type {(inputs: Carrier_Form_Package_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số kiện`)
};

/**

* @param {Carrier_Form_Package_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_package_count = /** @type {((inputs?: Carrier_Form_Package_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Package_CountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_package_count(inputs)
});